import React from "react";

export const DepotIcon = ({
  width = 16,
  height = 16,
  color1 = "#000000",
  className = "",
  cursor = "pointer",
  style = {},
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    className={className}
    cursor={cursor}
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_3524_52121)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2764 1.38897C11.4064 1.32398 11.5582 1.31875 11.6923 1.37464L15.6895 3.04014C15.6962 3.04288 15.7028 3.04577 15.7094 3.04881C15.7146 3.05121 15.7198 3.05371 15.7249 3.05628C15.7621 3.07501 15.7964 3.09809 15.8272 3.12475C15.858 3.15141 15.8853 3.18165 15.9086 3.21472C15.9458 3.26746 15.9728 3.32739 15.9874 3.39143C15.9938 3.41917 15.9978 3.44769 15.9993 3.47672L15.9998 3.48828C16 3.49378 16 3.49927 16 3.50475V11.5028C16 11.6858 15.9001 11.8542 15.7394 11.9418L8.40609 15.9418C8.28065 16.0102 8.13291 16.0213 8 15.9743C7.86709 16.0213 7.71935 16.0102 7.59391 15.9418L0.260574 11.9418C0.0999438 11.8542 0 11.6858 0 11.5028V7.50285C0 7.32638 0.0930227 7.16298 0.244768 7.0729C0.262024 7.06265 0.279749 7.05353 0.297841 7.04553L3.66667 5.51974V5.50285C3.66667 5.41148 3.69157 5.3239 3.73637 5.24821C3.78128 5.17231 3.8462 5.10837 3.92606 5.06454C3.93234 5.0611 3.93867 5.0578 3.94505 5.05464L11.2764 1.38897ZM4.66667 9.19383V6.31187L5.66667 6.81187V9.69383L4.66667 9.19383ZM6.66667 10.1938L7.66667 10.6938V7.81187L6.66667 7.31187V10.1938ZM8.66667 10.5272V7.79966L15 4.34512V7.20603L11.6017 9.05963L8.66667 10.5272ZM11.5189 2.38573L5.2847 5.50285L8.1566 6.9388L14.345 3.56328L11.5189 2.38573ZM3.66667 9.79967L1 8.34512V11.206L3.66667 12.6606V9.79967ZM11.3333 10.3451V13.1938L8.66667 14.5272V11.7997L11.3333 10.3451ZM4.66667 10.3451L7.59391 11.9418C7.61746 11.9546 7.64179 11.9655 7.66667 11.9743V14.6938L4.66667 13.1938V10.3451Z"
        fill={color1}
      />
    </g>
    <defs>
      <clipPath id="clip0_3524_52121">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DepotIcon;
